// DEV/QA pseudo-localization helper.
// Visual i18n verification: anything that went through transloco gets accented look-alike
// letters (Choose Date → Çĥöösë Đäţë).
// Text shown in PLAIN Latin on screen = hardcoded (not translated).
// Runtime toggle (no rebuild): localStorage.setItem('i18nDebug','1') + reload.
// Disable: localStorage.removeItem('i18nDebug').
import { Injectable } from '@angular/core';
import { TRANSLOCO_TRANSPILER, type Translation, type TranspileParams } from '@jsverse/transloco';

import { CspSafeMessageFormatTranspiler } from '@finverity/i18n';

// Look-alike but clearly accented Latin doubles.
const PSEUDO_CHAR_MAP: Record<string, string> = {
  a: 'ä',
  b: 'ƀ',
  c: 'ç',
  d: 'đ',
  e: 'ë',
  f: 'ƒ',
  g: 'ĝ',
  h: 'ĥ',
  i: 'ï',
  j: 'ĵ',
  k: 'ķ',
  l: 'ł',
  m: 'ɱ',
  n: 'ň',
  o: 'ö',
  p: 'þ',
  q: 'ɋ',
  r: 'ř',
  s: 'š',
  t: 'ţ',
  u: 'ü',
  v: 'ṽ',
  w: 'ŵ',
  x: 'ẋ',
  y: 'ÿ',
  z: 'ž',
  A: 'Ä',
  B: 'Ɓ',
  C: 'Ç',
  D: 'Đ',
  E: 'Ë',
  F: 'Ƒ',
  G: 'Ĝ',
  H: 'Ĥ',
  I: 'Ï',
  J: 'Ĵ',
  K: 'Ķ',
  L: 'Ł',
  M: 'Ṁ',
  N: 'Ň',
  O: 'Ö',
  P: 'Þ',
  Q: 'Ɋ',
  R: 'Ř',
  S: 'Š',
  T: 'Ţ',
  U: 'Ü',
  V: 'Ṽ',
  W: 'Ŵ',
  X: 'Ẋ',
  Y: 'Ÿ',
  Z: 'Ž',
};

function pseudoLocalize(input: string): string {
  let output = '';
  for (const char of input) {
    output += PSEUDO_CHAR_MAP[char] ?? char; // non-letters (digits, spaces, punctuation, HTML) — unchanged
  }
  return output;
}

@Injectable()
export class I18nDebugTranspiler extends CspSafeMessageFormatTranspiler {
  override transpile(params: TranspileParams<Translation | string | string[]>): unknown {
    const result = super.transpile(params);

    if (typeof result === 'string' && localStorage.getItem('i18nDebug') === '1') {
      return pseudoLocalize(result);
    }

    return result;
  }
}

// DEV/QA pseudo-localization helper.
export const I18N_DEBUG_TRANSPILER_PROVIDER = {
  provide: TRANSLOCO_TRANSPILER,
  useClass: I18nDebugTranspiler,
};
